import React from "react";
import RotatePhoneIcon from "../../images/rotatePhone.svg"
import { Modal, Grid, Box, Typography } from "@mui/material";

const index = ({ isOpen }) => {

  return (
    <Grid open={isOpen} style={{height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {/* <Typography variant="h2" color={"#003E4C"}>Rotate Phone</Typography> */}
      <img src={RotatePhoneIcon} alt="" width="200"/>
    </Grid>
  );
};

export default index;
